"use client";

import { useEffect } from "react";

export function useOnIframeClick(onIframeClick?: () => unknown) {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const blurEventListener = () => {
      setTimeout(() => {
        if (document.activeElement?.tagName === "IFRAME") {
          onIframeClick?.();
        }
      });
    };

    window.focus();

    window.addEventListener("blur", blurEventListener, { once: true });

    return () => {
      window.removeEventListener("blur", blurEventListener);
    };
  }, [onIframeClick]);
}
